
import { Component, Vue } from 'vue-property-decorator';
import SMSRepositoryInterface from '@/services/SMS/interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { DataTableHeader } from 'vuetify';
import { SmsEntityInterface } from '@/services/SMS/interfaces/sms.interfaces';

@Component({
  inject: ['smsRepository'],
})
export default class SmsList extends Vue{
  private loading: boolean = true

  private headers: DataTableHeader[] = [
    { text: 'Date', value: 'createdAt'},
    { text: 'Origin', value: 'senderName' },
    { text: 'Destination', value: 'clientPhoneNumber' },
    { text: 'Message', value: 'message'},
    { text: 'status', value: 'status', sortable: false },
  ]

  public sms: SmsEntityInterface[] = []

  private readonly smsRepository: SMSRepositoryInterface;

  private async mounted(): Promise<void> {
    await this.initialize()
    this.loading = false
  }
  private async initialize(): Promise<void> {
    this.sms = await this.getAllSms()
  }


  private async getAllSms(): Promise<SmsEntityInterface[]> {
    try {
      return await this.smsRepository.getAllSms()
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve templates: ' +  e.message);
      return []
    }
  }

  private formatDate(timestamp: string) {
    const date = new Date(timestamp)
    return date.toLocaleString() // returns a string in the format "4/4/2023, 3:04:36 PM" (based on the user's browser settings)
  }

  private createSms(): void {
    this.$router.push({ name: 'sms_add' })
  }
}
